import React from "react";
import styles from "./TableComp.module.css";

export default function TableComp({
  columns = [],
  rows = [],
  loading = false,
  loadingRows = 5,
  emptyMessage = "No records found.",
  onRowClick,
}) {
  const skeletonRows = Array.from({ length: loadingRows }, (_, index) => index);

  return (
    <div className={styles.tableWrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((column, idx) => (
              <th key={column.key || idx}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            skeletonRows.map((index) => (
              <tr key={`skeleton-${index}`} className={styles.loadingRow}>
                {columns.map((column, colIndex) => (
                  <td key={column.key || colIndex}>
                    <span className={styles.skeleton} />
                  </td>
                ))}
              </tr>
            ))
          ) : rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className={styles.stateCell}>
                {emptyMessage}
              </td>
            </tr>
          ) : (
            rows.map((row, rowIndex) => (
              <tr
                key={row.id ?? rowIndex}
                onClick={() => onRowClick?.(row)}
                className={onRowClick ? styles.clickable : ""}
              >
                {columns.map((column, idx) => (
                  <td key={column.key || idx}>
                    {column.render ? column.render(row, rowIndex) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
